var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$store.getters.getMultiOpt === 1)?_c('form-login'):(this.$store.getters.getMultiOpt === 2)?_c('reset-password'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }